var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVisibilityOffSGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5C15.26 7.5 17.5 9.74 17.5 12.5C17.5 13.15 17.37 13.76 17.14 14.33L20.06 17.25C21.57 15.99 22.76 14.36 23.49 12.5C21.76 8.11 17.49 5 12.49 5C11.09 5 9.75 5.25 8.51 5.7L10.67 7.86C11.24 7.63 11.85 7.5 12.5 7.5ZM2.5 4.77L4.78 7.05L5.24 7.51C3.58 8.8 2.28 10.52 1.5 12.5C3.23 16.89 7.5 20 12.5 20C14.05 20 15.53 19.7 16.88 19.16L17.3 19.58L20.23 22.5L21.5 21.23L3.77 3.5L2.5 4.77ZM8.03 10.3L9.58 11.85C9.53 12.06 9.5 12.28 9.5 12.5C9.5 14.16 10.84 15.5 12.5 15.5C12.72 15.5 12.94 15.47 13.15 15.42L14.7 16.97C14.03 17.3 13.29 17.5 12.5 17.5C9.74 17.5 7.5 15.26 7.5 12.5C7.5 11.71 7.7 10.97 8.03 10.3ZM12.34 9.52L15.49 12.67L15.51 12.51C15.51 10.85 14.17 9.51 12.51 9.51L12.34 9.52Z",
    fill: "#008148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibilityOffSGreen);
export default __webpack_public_path__ + "static/media/icon-visibility_off-s-green.2ef0e3c8c74d7f89be707cae8fe9d331.svg";
export { ForwardRef as ReactComponent };